module.exports = __webpack_public_path__ + "img/CAT_CHEMICAL_MADE_REAGENT.072686e4.svg";